<a
  class="grid items-center grid-cols-7 gap-3 p-1 cursor-pointer hover:bg-grey-5 dark:hover:bg-grey-13 rounded-5 max-sm:text-11"
  [routerLink]="[getUrlForMatch()]"
>
  <div
    class="grid items-center grid-cols-2 col-span-3 max-sm:flex max-sm:gap-1 max-sm:flex-col max-sm:items-start max-sm:col-span-2"
  >
    <div class="text-grey-2 font-roboto-600">
      {{ match().matchDate }}
    </div>
    <div
      class="flex items-center gap-2 max-sm:gap-1 text-grey-2 font-roboto-600"
    >
      <img
        alt="logo"
        class="w-[24px] h-[24px] max-sm:w-[18px] max-sm:h-[18px] object-contain"
        [src]="match().competition.logo"
      />
      {{ match().competition.name }}
    </div>
  </div>

  <div
    class="flex flex-col col-span-3 gap-3 max-sm:gap-1 font-roboto-600 text-blue max-sm:col-span-4"
  >
    <div class="grid grid-cols-12">
      <div class="col-span-2">
        <img
          alt="logo"
          class="w-[24px] h-[24px] max-sm:w-[18px] max-sm:h-[18px] object-contain"
          [src]="match().home.logo"
        />
      </div>
      <div
        class="col-span-8 font-roboto-600"
        [ngClass]="{
          'winner-team': match().home.score > match().away.score
        }"
      >
        {{ match().home.name }}
      </div>
      <div
        class="col-span-2 text-end font-roboto-600"
        [ngClass]="{
          'winner-team': match().home.score > match().away.score
        }"
      >
        {{ match().home.penaltyScore && "(" + match().home.penaltyScore + ")" }}
        {{ match().home.score }}
      </div>
    </div>
    <div class="grid grid-cols-12">
      <div class="col-span-2">
        <img
          alt="logo"
          class="w-[24px] h-[24px] max-sm:w-[18px] max-sm:h-[18px] object-contain"
          [src]="match().away.logo"
        />
      </div>
      <div
        class="col-span-8 font-roboto-600"
        [ngClass]="{
          'winner-team': match().home.score < match().away.score
        }"
      >
        {{ match().away.name }}
      </div>
      <div
        class="col-span-2 text-end font-roboto-600"
        [ngClass]="{
          'winner-team': match().home.score < match().away.score
        }"
      >
        {{ match().away.penaltyScore && "(" + match().away.penaltyScore + ")" }}
        {{ match().away.score }}
      </div>
    </div>
  </div>

  <div class="flex justify-end font-roboto-600">
    @if(match().result){

    <div
      class="rounded-full max-w-[50px] flex justify-center items-center text-white w-full p-3"
      [ngClass]="{
        'bg-green-1': letterWin.includes(result()),
        'bg-red-2': letterLose.includes(result()),
        'bg-grey-1': letterDraw.includes(result())
      }"
    >
      <!-- // 'bg-grey-1': !['W', 'L'].includes(result()) -->
      {{ result() | translate }}
    </div>
    }
  </div>
</a>
